export const modalWidth = 695 //px
export const padding = 25 //px
export const sideMargins = 2 // px
const totalMargin = sideMargins * 2 // left & right
const totalPadding = padding * 2 // left & right
export const blocksWidth = dataLen =>
    modalWidth - (totalPadding + totalMargin * dataLen)
